export default __webpack_public_path__ + "static/media/verified-error.72c6dded.svg";